import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { fectchJournalToday, updateJournalToday } from '../../Components/action/common'
import {useDispatch} from 'react-redux'
import { setJournalList, updateJournalList } from '../../redux/slices/TaskSlice'

function JournalSection() {

  const dispatch=useDispatch()
  const {  dateChange  , journalList } = useSelector(state => state.task)
  const [gratitude,setGratitude]=useState({})
  const [morningReflection,setMorningReflection]=useState('')

  function auto_grow(e, target) {
    const element = target ?? e.target;
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  const fetchJournalData = async () => {
    try {
      let response = await fectchJournalToday({ "date": moment(dateChange).startOf('date').toISOString() })
      dispatch(setJournalList(response?.data?.responseData ?? []));
      setGratitude(response?.data?.responseData?.[1] ?? {})
      getMorningReflection(response?.data?.responseData?.[1] ?? {});
      setTimeout(() => document.querySelectorAll('.textarea-lines').forEach(element => auto_grow(null, element)), 1)
    } catch ({ response }) {
    }
  }

  const updateInCache = (e) => {
    const {name, value} = e.target;
    let requestBody = {
      [name]: value,
      "date": moment(dateChange).startOf('date').toISOString()
    }
    dispatch(updateJournalList(requestBody ?? {}));
  }

  const updateJournal = async (e) => {
    let gratitude = e?.target?.value
    let requestBody = {
      "gratitude": gratitude,
      "date": moment(dateChange).startOf('date').toISOString()
    }

    setGratitude(g => ({...g, gratitude}));

    try {
      let response = await updateJournalToday(requestBody);
      
    } catch ({ response }) {
    }
  }

  const updateJournalNotes = async (e) => {
    let notesData = e?.target?.value
    let requestBody = {
      "notes": notesData,
      "date": moment(dateChange).startOf('date').toISOString()
    }
    setGratitude(g => ({...g, notes: notesData}));
    
    try {
      let response = await updateJournalToday(requestBody)
    } catch ({ response }) {

    }
  }

  useEffect(() => {
    let x=journalList.find(o => o.date ===  moment(dateChange).startOf('date').toISOString())
    if(x == undefined){
      fetchJournalData()
    }else{
      getMorningReflection(x);
      setGratitude(x ?? {})
    }
    
    setTimeout(() => document.querySelectorAll('.textarea-lines').forEach(element => auto_grow(null, element)), 1)
  }, [ dateChange])

  useEffect(() => {
    let x=journalList.find(o => o.date ===  moment(dateChange).startOf('date').toISOString())
    getMorningReflection(x);

    setGratitude(x ?? {})
    
  }, [])

  const getMorningReflection = (x) => {
    let content = '';
    if(x?.morningReflection){
      content = x?.morningReflection
    }
    // if(x?.morningReflection?.conversation){
    //   const morningReflection = JSON.parse(x?.morningReflection?.conversation)
    //   morningReflection.map(o => {
    //     content += (o.role === 'user' ? 'User' : 'AI Assistant') + ": \n" + o.content + "\n\n"
    //   })
    // }

    setMorningReflection(content)
  }

  return (
    <div className="task-list todayJournal">
      
    <div className="list-tag-name">
      <label className="task-tag !font-madena"><span className="text-black dark:text-white">Journal</span> <span className="dark:text-white dark:opacity-30">Reflect on your day</span></label>
    </div>
    <div className="list-tag-name textGratitude">
      <label className="task-tag sub-task-tag dark:text-white">Gratitude</label>
      <div>
        <textarea name="gratitude" value={  gratitude?.gratitude ?? ''} placeholder='What are you grateful for today?' className={`journal-input gratitude textarea-lines !text-base !font-inter placeholder:text-black1 dark:placeholder:text-white/30 text-black dark:text-white min-h-[auto]`} onInput={auto_grow}  onChange={(e) => { updateJournal(e); }} onBlur={updateInCache} ></textarea>
      </div>
    </div>
    {
      morningReflection &&
      <div className="list-tag-name textGratitude">
        <label className="task-tag sub-task-tag dark:text-white">Morning Reflection</label>
        <div>
          <div className={`journal-input gratitude textarea-lines text-black dark:text-white min-h-[auto]`}>
            <div dangerouslySetInnerHTML={{ __html: morningReflection }} className="*:text-black dark:*:text-white" />
          </div>
        </div>
      </div>
    }
    <div className="list-tag-name textNotes">
      <label className="task-tag sub-task-tag dark:text-white">Notes</label>
      <div>
        <textarea name="notes" placeholder='Any notes for the day?' value={ gratitude?.notes ?? ''} className={`journal-input gratitude textarea-lines text-black dark:text-white placeholder:text-black1 dark:placeholder:text-white/30`} onInput={auto_grow} onChange={(e) => { updateJournalNotes(e); }} onBlur={updateInCache}></textarea>
      </div>
    </div>
  </div>
  )
}

export default JournalSection